import { render, staticRenderFns } from "./BaseSearchVehicle.vue?vue&type=template&id=855c7b66&scoped=true"
import script from "./BaseSearchVehicle.vue?vue&type=script&lang=js"
export * from "./BaseSearchVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855c7b66",
  null
  
)

export default component.exports